import React, { useMemo, useState, useEffect } from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ProjectCards from "../Projekti/ProjectCards";

// Leaflet (react-leaflet is already installed in your project)
import {
  MapContainer,
  TileLayer,
  CircleMarker,
  Tooltip,
  ZoomControl,
  useMap,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { latLngBounds } from "leaflet";

function FitBounds({ points }) {
  const map = useMap();

  useEffect(() => {
    if (!map) return;
    if (!points || points.length === 0) return;

    const bounds = latLngBounds(points);
    map.fitBounds(bounds, { padding: [24, 24] });
  }, [map, points]);

  return null;
}

function Erasmus() {
  const [t] = useTranslation();

  const CONTACT_EMAIL = "international@fpebar.me";
  const CHART_CODE = "ME BAR01";

  const documents = useMemo(
    () => [
      {
        title: "Erasmus Charter for Higher Education POVELJA",
        href: "/Prilozi/Erasmus Charter for Higher Education POVELJA.pdf",
        icon: "fas fa-scroll",
      },
      {
        title: "ERASMUS POLICY STATEMENT",
        href: "/Prilozi/ERASMUS POLICY STATEMENT.pdf",
        icon: "fas fa-file-signature",
      },
      {
        title:
          "Odluka o utvrđivanju kriterijuma za izbor studenata za učešće u programima mobilnosti",
        href: "/Prilozi/Odluka o utvrđivanju kriterijuma za izbor studenata za učešće u programima mobilnosti.pdf",
        icon: "fas fa-gavel",
      },
      {
        title:
          "Odluku o utvrđivanju kriterijumima za izbor nastavnog-nenastavnog osoblja u programima mobilnosti",
        href: "/Prilozi/Odluku o utvrđivanju  kriterijumima za izbor nastavnog-nenastavnog osoblja u programima mobilnosti.pdf",
        icon: "fas fa-user-check",
      },
      {
        title: "Erasmus+ Dissemination plan",
        href: "/Prilozi/Erasmus+ Dissemination plan at LSB.pdf",
        icon: "fas fa-bullhorn",
      },
      {
        title: "Erasmus+ Inclusion and diversity plan",
        href: "/Prilozi/Erasmus+ Inclusion and diversity plan.pdf",
        icon: "fas fa-people-arrows",
      },
    ],
    [],
  );

  // Map uses real lat/lng so react-leaflet can place pins.
  // URL is optional; if you fill it, pin becomes clickable.
  const partners = useMemo(
    () => [
      {
        id: "01",
        name: "Vasil Levski National Military University",
        country: t("erasmus.bugarska"),
        city: t("bugarska.grad1"),
        url: "https://www.nvu.bg/en",
        latLng: [43.0757, 25.6172],
      },
      {
        id: "02",
        name: "University of Macedonia",
        country: t("erasmus.grcka"),
        city: t("grcka.grad1"),
        url: "https://www.uom.gr/en",
        latLng: [40.6401, 22.9444],
      },
      {
        id: "03",
        name: "Veleučilište Baltazar Zaprešić",
        country: t("erasmus.hrvatska"),
        city: "Zagreb",
        url: "https://www.bak.hr/",
        latLng: [45.815, 15.9819],
      },
      {
        id: "04",
        name: "Universitatea Constantin Brâncuşi",
        country: t("erasmus.rumunija"),
        city: "Târgu-Jiu",
        url: "https://www.utgjiu.ro/",
        latLng: [45.045, 23.274],
      },
      {
        id: "05",
        name: "Lucian Blaga University of Sibiu",
        country: t("erasmus.rumunija"),
        city: "Sibiu",
        url: "https://www.ulbsibiu.ro/en/",
        latLng: [45.7936, 24.15],
      },
      {
        id: "06",
        name: "Ljubljana School of Business B2",
        country: t("erasmus.slovenija"),
        city: "Ljubljana",
        url: "https://www.vspv.si/en/about-school",
        latLng: [46.0569, 14.5058],
      },
      {
        id: "07",
        name: "Univerzitet Educons",
        country: t("erasmus.srbija"),
        city: "Sremska Kamenica",
        url: "https://educons.edu.rs/",
        latLng: [45.2515, 19.857],
      },
      {
        id: "08",
        name: "University of Granada",
        country: t("erasmus.spanija"),
        city: "Granada",
        url: "https://www.ugr.es/",
        latLng: [37.1773, -3.5986],
      },
      {
        id: "09",
        name: "Jaume I University",
        country: t("erasmus.spanija"),
        city: "Castelló de la Plana",
        url: "https://www.uji.es/",
        latLng: [39.9864, -0.0513],
      },
      {
        id: "10",
        name: "Sakarya University of Applied Sciences",
        country: t("erasmus.turska"),
        city: "Sakarya",
        url: "https://subu.edu.tr/?lang=en",
        latLng: [40.7731, 30.3948],
      },
      {
        id: "11",
        name: "Higher Vocational School Iceps",
        country: t("erasmus.slovacka"),
        city: "Ružomberok",
        url: "",
        latLng: [49.08, 19.307],
      },
      {
        id: "12",
        name: "Istanbul University",
        country: t("erasmus.turska"),
        city: "Istanbul",
        url: "https://www.istanbul.edu.tr/tr/_",
        latLng: [41.0082, 28.9784],
      },
      {
        id: "13",
        name: "Istanbul Gedik University",
        country: t("erasmus.turska"),
        city: "Istanbul",
        url: "https://www.gedik.edu.tr/",
        latLng: [40.9819, 29.128],
      },
      {
        id: "14",
        name: "Sivas Cumhuriyet University",
        country: t("erasmus.turska"),
        city: t("turska.grad1"),
        url: "https://www.cumhuriyet.edu.tr/",
        latLng: [39.7477, 37.0179],
      },
      {
        id: "15",
        name: "Izmir Bakircay University",
        country: t("erasmus.turska"),
        city: t("turska.grad2"),
        url: "https://bakircay.edu.tr/",
        latLng: [38.4237, 27.1428],
      },
      {
        id: "16",
        name: "Afyon Kocatepe University",
        country: t("erasmus.turska"),
        city: "Afyonkarahisar",
        url: "https://aku.edu.tr/",
        latLng: [38.7617, 30.5403],
      },
      {
        id: "17",
        name: "Tarsus University",
        country: t("erasmus.turska"),
        city: "Tarsus",
        url: "https://www.tarsus.edu.tr/Website/Default.aspx",
        latLng: [36.9167, 34.9],
      },
      {
        id: "18",
        name: "Universidad del Atlántico Medio (UNAM)",
        country: t("erasmus.spanija"),
        city: "Las Palmas de Gran Canaria",
        url: "https://www.universidadatlanticomedio.es/",
        latLng: [28.1235, -15.4363],
      },
      {
        id: "19",
        name: '"Nicolae Bălcescu" Land Forces Academy',
        country: t("erasmus.rumunija"),
        city: "Sibiu",
        url: "https://www.armyacademy.ro/engleza/",
        latLng: [45.8, 24.15],
      },
      {
        id: "20",
        name: "University Rzeszowski",
        country: t("erasmus.poljska"),
        city: "Rzeszów",
        url: "https://www.ur.edu.pl/en/home",
        latLng: [50.04132, 21.99901],
      },
      {
        id: "21",
        name: "University of Management Personnel",
        country: t("erasmus.poljska"),
        city: "Konin",
        url: "https://www.wskm.edu.pl/about-the-university",
        latLng: [52.22338, 18.25121],
      },
      {
        id: "22",
        name: "Kadir Has University",
        country: t("erasmus.turska"),
        city: "Istanbul",
        url: "https://www.khas.edu.tr/en/",
        latLng: [41.01361, 28.955],
      },
      {
        id: "23",
        name: "Agricultural University of Athens",
        country: t("erasmus.grcka"),
        city: "Atina",
        url: "https://www2.aua.gr/en",
        latLng: [37.98381, 23.727539],
      },
      {
        id: "24",
        name: "Istanbul Kultur University",
        country: t("erasmus.turska"),
        city: "Istanbul",
        url: "https://aday.iku.edu.tr/",
        latLng: [41.01361, 28.955],
      },
      {
        id: "25",
        name: "Alanya Alaaddin Keykubat University",
        country: t("erasmus.turska"),
        city: "Alanja",
        url: "https://www.alanya.edu.tr/en",
        latLng: [36.549362, 31.996994],
      },
      {
        id: "26",
        name: "Sveučilište u Splitu",
        country: t("erasmus.hrvatska"),
        city: "Split",
        url: "https://www.unist.hr/",
        latLng: [43.508133, 16.440193],
      },
      {
        id: "27",
        name: "International Business School of Bulgaria",
        country: t("erasmus.bugarska"),
        city: "Sofija",
        url: "https://ibsedu.bg/en/",
        latLng: [42.698334, 23.319941],
      },
      {
        id: "28",
        name: "SMK Higher Vocational School",
        country: t("erasmus.litvanija"),
        city: "Vilnius/Klaipeda",
        url: "https://smk.lt/en/",
        latLng: [54.687157, 25.279652],
      },
      {
        id: "29",
        name: "Universidade Portugalese",
        country: t("erasmus.portugal"),
        city: "Porto",
        url: "https://www.up.pt/portal/en/",
        latLng: [41.1496, -8.61099],
      },
      {
        id: "30",
        name: "Daugavpils University",
        country: t("erasmus.letonija"),
        city: "Daugavpils",
        url: "https://du.lv/en/home/",
        latLng: [55.88333, 26.53333],
      },
      {
        id: "31",
        name: "Luxembourg Business School",
        country: "Luxemburg",
        city: "Luxemburg",
        url: "https://luxsb.lu/",
        latLng: [49.611622, 6.131935],
      },
      {
        id: "32",
        name: "University of Applied Sciences - hochshcule burgenland",
        country: t("erasmus.austrija"),
        city: "Eisenstadt",
        url: "https://hochschule-burgenland.at/en/",
        latLng: [47.84565, 16.52327],
      },
      {
        id: "33",
        name: "Klaipėdos valstybinė kolegija",
        country: t("erasmus.litvanija"),
        city: "Klaipėda",
        url: "https://www.kvk.lt/",
        latLng: [55.703297, 21.144279],
      },
      {
        id: "34",
        name: "St.Cyril and St.Methodius University of Veliko Tarnovo",
        country: t("erasmus.bugarska"),
        city: "Velika Trnavo",
        url: "https://www.uni-vt.bg/eng/",
        latLng: [43.075672, 25.617151],
      },
      {
        id: "35",
        name: "Hitit University",
        country: t("erasmus.turska"),
        city: "Corum",
        url: "https://hitit.edu.tr/en",
        latLng: [40.5489, 34.9533],
      },
      {
        id: "36",
        name: '"Ovidius" University of Constanta',
        country: t("erasmus.rumunija"),
        city: "Constanta",
        url: "https://en.univ-ovidius.ro/",
        latLng: [44.179249, 28.64994],
      },
      {
        id: "37",
        name: '"Ovidius" University of Constanta',
        country: t("erasmus.turska"),
        city: "Bursa",
        url: "",
        latLng: [40.193298, 29.074202],
      },
      {
        id: "38",
        name: "MANS Warszawa",
        country: t("erasmus.poljska"),
        city: "Varšava",
        url: "https://mans.org.pl/",
        latLng: [52.237049, 21.017532],
      },
      {
        id: "39",
        name: "The John Paul II Catholic University of Lublin",
        country: t("erasmus.poljska"),
        city: "Lublin",
        url: "https://www.kul.pl/",
        latLng: [51.246452, 22.568445],
      },
      {
        id: "40",
        name: "Politehnic University",
        country: t("erasmus.portugal"),
        city: "Castelo Branco",
        url: "https://portugalpolytechnicuniversities.com/en/polytechnic/instituto-politecnico-de-castelo-branco/",
        latLng: [39.8222, -7.4909],
      },
      {
        id: "41",
        name: "Fakulteta za komercijalne i poslovne vede",
        country: t("erasmus.slovenija"),
        city: "Celje",
        url: "https://www.fkpv.si/",
        latLng: [46.23092, 15.26044],
      },
      {
        id: "42",
        name: "Univerzitet u Novom Pazaru",
        country: t("erasmus.srbija"),
        city: "Novi Pazar",
        url: "https://uninp.edu.rs/eng/",
        latLng: [43.1367, 20.5122],
      },
      {
        id: "43",
        name: "Wyzsza Szkola Przedsiebiorczoscii Administracji W Lublinie",
        country: t("erasmus.poljska"),
        city: "Lublin",
        url: "https://wspa.pl/",
        latLng: [51.246452, 22.568445],
      },
      {
        id: "44",
        name: "The University in Wrocław",
        country: t("erasmus.poljska"),
        city: "Wroclaw",
        url: "https://uwr.edu.pl/en/",
        latLng: [51.107883, 17.038538],
      },
      {
        id: "45",
        name: "IBA International Business Academy",
        country: t("erasmus.danska"),
        city: "Kolding",
        url: "https://iba.dk/international/",
        latLng: [55.495972, 9.473052],
      },
      {
        id: "46",
        name: "Eastern European University of Applied Sciences",
        country: t("erasmus.poljska"),
        city: "Bijalstok",
        url: "https://wans.edu.pl/en/",
        latLng: [53.132489, 23.16884],
      },
      {
        id: "47",
        name: "EFFECTUS veleučilište",
        country: t("erasmus.hrvatska"),
        city: "Zagreb",
        url: "https://effectus.com.hr/",
        latLng: [45.815399, 15.966568],
      },
      {
        id: "48",
        name: "Nikola Vaptsarov Naval Academy",
        country: t("erasmus.bugarska"),
        city: "Varna",
        url: "https://www.naval-acad.bg/en",
        latLng: [43.204666, 27.910543],
      },
      {
        id: "49",
        name: "University of National and World Economy",
        country: t("erasmus.bugarska"),
        city: "Sofija",
        url: "https://www.unwe.bg/en/",
        latLng: [42.698334, 23.319941],
      },
      {
        id: "50",
        name: "University of Economics",
        country: t("erasmus.bugarska"),
        city: "Varna",
        url: "https://www.ue-varna.bg/en/",
        latLng: [43.204666, 27.910543],
      },
      {
        id: "51",
        name: "CY Cergy Paris Université, CY Tech",
        country: t("erasmus.francuska"),
        city: "Pariz",
        url: "https://cytech.cyu.fr/",
        latLng: [48.864716, 2.349014],
      },
      {
        id: "52",
        name: "Opole University of Technology",
        country: t("erasmus.poljska"),
        city: "Opole",
        url: "https://po.edu.pl/?lang=en",
        latLng: [50.671062, 17.926126],
      },
      {
        id: "53",
        name: "University of Bialystok",
        country: t("erasmus.poljska"),
        city: "Bjalistok",
        url: "https://uwb.edu.pl/en/university/science-4008/research/university-research/faculty-of-law-966",
        latLng: [53.132489, 23.16884],
      },
      {
        id: "54",
        name: "Transilvania University of Brasov",
        country: t("erasmus.rumunija"),
        city: "Brasov",
        url: "https://www.unitbv.ro/en/",
        latLng: [45.657974, 25.601198],
      },
      {
        id: "55",
        name: "University of Bucharest",
        country: t("erasmus.rumunija"),
        city: "Bukurešt",
        url: "https://unibuc.ro/?lang=en",
        latLng: [44.439663, 26.096306],
      },
      {
        id: "56",
        name: "Visoka škola elektrotehnike i računarstva",
        country: t("erasmus.srbija"),
        city: "Beograd",
        url: "https://www.viser.edu.rs/",
        latLng: [44.787197, 20.457273],
      },
      {
        id: "57",
        name: "Universitas Catholica Ružomberok",
        country: t("erasmus.slovacka"),
        city: "Ružomberku",
        url: "https://www.ku.sk/en/",
        latLng: [49.0748, 19.30751],
      },
      {
        id: "58",
        name: "Akademija strukovnih studija Šabac",
        country: t("erasmus.srbija"),
        city: "Šabac",
        url: "https://www.akademijasabac.edu.rs/",
        latLng: [44.74667, 19.69],
      },
      {
        id: "59",
        name: "ICEPS Internacionalni centar za profesionalne studije",
        country: t("erasmus.srbija"),
        city: "Novi Sad",
        url: "https://iceps.edu.rs/",
        latLng: [45.267136, 19.833549],
      },
      {
        id: "60",
        name: "Karamanoglu Mehmetbey University",
        country: t("erasmus.turska"),
        city: "Karaman",
        url: "https://www.kmu.edu.tr/en",
        latLng: [37.1811, 33.215],
      },
      {
        id: "61",
        name: "Vilnius Business College",
        country: t("erasmus.litvanija"),
        city: "Vilinus",
        url: "https://www.kolegija.lt/en/vilnius-business-college/",
        latLng: [54.687157, 25.279652],
      },
    ],
    [t],
  );

  const [partnerQuery, setPartnerQuery] = useState("");

  const filteredPartners = useMemo(() => {
    const q = partnerQuery.trim().toLowerCase();
    if (!q) return partners;
    return partners.filter((p) => {
      const hay = `${p.id} ${p.name} ${p.country} ${p.city}`.toLowerCase();
      return hay.includes(q);
    });
  }, [partnerQuery, partners]);

  const mapPoints = useMemo(() => partners.map((p) => p.latLng), [partners]);

  return (
    <>
      <Navbar />
      <Bredcom title={t("breadcrumb.home")} subtitle={t("pages.erasmus")} />

      <div className="container mt-4 pt-40 erasmus-page">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              {/* HERO */}
              <section className="erasmus-hero" aria-label="Erasmus hero">
                <div className="erasmus-hero__left">
                  <div className="erasmus-hero__badges">
                    <span className="erasmus-badge">{CHART_CODE}</span>
                    <span className="erasmus-badge erasmus-badge--soft">
                      Erasmus+
                    </span>
                  </div>

                  <h1 className="erasmus-hero__title">{t("erasmus.title")}</h1>

                  <p className="erasmus-hero__lead">
                    <strong>{t("erasmus.mebar01")}</strong>
                  </p>

                  <div className="erasmus-hero__meta">
                    <div className="erasmus-metaRow">
                      <span className="erasmus-metaRow__icon">
                        <i className="fas fa-envelope"></i>
                      </span>
                      <span className="erasmus-metaRow__label">EMAIL:</span>
                      <span className="erasmus-metaRow__value">
                        <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="erasmus-hero__right">
                  <Link
                    to="/erasmus-konkursi"
                    className="erasmus-ctaCard"
                    aria-label={t("erasmus.ui.openCallsAria")}
                  >
                    <div className="erasmus-ctaCard__bg" aria-hidden="true" />
                    <div className="erasmus-ctaCard__content">
                      <div className="erasmus-ctaCard__eyebrow">
                        {t("erasmus.ui.openCallsEyebrow")}
                      </div>
                      <div className="erasmus-ctaCard__title">
                        {t("erasmusKonkurs.subtitle")}
                      </div>
                      <div className="erasmus-ctaCard__subtitle">
                        {t("erasmus.ui.openCallsSubtitle")}
                      </div>
                    </div>
                    <div className="erasmus-ctaCard__icon" aria-hidden="true">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </Link>

                  <div className="erasmus-quickLinks">
                    <a href="#erasmus-documents" className="erasmus-quickLink">
                      <i className="fas fa-file-alt"></i>
                      <span>{t("erasmus.ui.quickDocs")}</span>
                    </a>
                    <a href="#erasmus-partners" className="erasmus-quickLink">
                      <i className="fas fa-globe-europe"></i>
                      <span>{t("erasmus.ui.quickPartners")}</span>
                    </a>
                  </div>
                </div>
              </section>

              {/* DOCUMENTS */}
              <section id="erasmus-documents" className="erasmus-block">
                <div className="erasmus-blockHeader">
                  <h2 className="erasmus-blockTitle">
                    {t("erasmus.ui.documentsTitle")}
                  </h2>
                  <p className="erasmus-muted">
                    {t("erasmus.ui.documentsSubtitle")}
                  </p>
                </div>

                <div className="erasmus-docGrid">
                  {documents.map((doc) => (
                    <a
                      key={doc.href}
                      className="erasmus-docCard"
                      href={doc.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`${doc.title} (PDF)`}
                    >
                      <div className="erasmus-docCard__icon" aria-hidden="true">
                        <i className={doc.icon}></i>
                      </div>
                      <div className="erasmus-docCard__body">
                        <div className="erasmus-docCard__title">
                          {doc.title}
                        </div>
                        <div className="erasmus-docCard__meta">
                          PDF <i className="fas fa-external-link-alt"></i>
                        </div>
                      </div>
                    </a>
                  ))}
                </div>
              </section>

              {/* TEXT (do not edit content) */}
              <section className="erasmus-copy">
                <p>{t("erasmus.p1")}</p>
                <p>{t("erasmus.p2")}</p>
                <p>{t("erasmus.p3")}</p>
                <p>{t("erasmus.p4")}</p>
                <p>{t("erasmus.p5")}</p>
              </section>

              {/* DO NOT TOUCH: Erasmus+ projects section */}
              <ProjectCards
                layout="sidebar"
                title={t("projects.sidebar.erasmus.title")}
                subtitle={t("projects.sidebar.erasmus.subtitle")}
              />

              {/* PARTNERS */}
              <section id="erasmus-partners" className="erasmus-block">
                <div className="erasmus-partnersHeader">
                  <div>
                    <h2 className="erasmus-blockTitle">
                      {t("erasmus.ui.partnersTitle")}
                    </h2>
                    <p className="erasmus-muted">{t("erasmus.spisak")}</p>
                  </div>

                  <div className="erasmus-search" role="search">
                    <i className="fas fa-search" aria-hidden="true"></i>
                    <input
                      type="text"
                      value={partnerQuery}
                      onChange={(e) => setPartnerQuery(e.target.value)}
                      placeholder={t("erasmus.ui.partnersSearch")}
                      aria-label={t("erasmus.ui.partnersSearchAria")}
                    />
                    <span className="erasmus-search__count" aria-hidden="true">
                      {filteredPartners.length}
                    </span>
                  </div>
                </div>

                {/* Table: col-8 centered */}

                <div className="erasmus-tableWrap">
                  <table className="erasmus-table">
                    <thead>
                      <tr>
                        <th scope="col">{t("erasmus.rb")}</th>
                        <th scope="col">{t("erasmus.nazivUstanove")}</th>
                        <th scope="col">{t("erasmus.drzava")}</th>
                        <th scope="col">{t("erasmus.grad")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredPartners.map((p) => (
                        <tr key={p.id}>
                          <td className="erasmus-td--mono">{p.id}</td>
                          <td className="erasmus-td--strong">{p.name}</td>
                          <td>{p.country}</td>
                          <td>{p.city}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Map below table: col-8 centered */}
                {/* Map below table: full width */}
                <div className="erasmus-mapCard mt-3">
                  <div className="erasmus-mapHeader">
                    <div className="erasmus-mapTitle">
                      {t("erasmus.ui.mapTitle")}
                    </div>
                    <div className="erasmus-mapHint">
                      {t("erasmus.ui.mapHint")}
                    </div>
                  </div>

                  <div className="erasmus-leafletWrap">
                    <MapContainer
                      className="erasmus-leafletMap"
                      center={[42, 12]}
                      zoom={3}
                      minZoom={2}
                      scrollWheelZoom={false}
                      zoomControl={false}
                    >
                      <ZoomControl position="bottomright" />
                      <TileLayer
                        url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
                      />

                      <FitBounds points={mapPoints} />

                      {partners.map((p) => (
                        <CircleMarker
                          key={p.id}
                          center={p.latLng}
                          radius={6}
                          pathOptions={{
                            color: "#9a286a",
                            weight: 2,
                            fillColor: "#fbc07d",
                            fillOpacity: 0.85,
                          }}
                          eventHandlers={
                            p.url
                              ? {
                                  click: () =>
                                    window.open(
                                      p.url,
                                      "_blank",
                                      "noopener,noreferrer",
                                    ),
                                }
                              : undefined
                          }
                        >
                          <Tooltip
                            direction="top"
                            offset={[0, -6]}
                            opacity={1}
                            sticky
                          >
                            <div className="erasmus-leafletTip">
                              <div className="erasmus-leafletTip__title">
                                {p.name}
                              </div>
                              <div className="erasmus-leafletTip__meta">
                                {p.city}, {p.country}
                              </div>
                              <div className="erasmus-leafletTip__meta">
                                {t("erasmus.ui.website")}: {p.url ? p.url : "-"}
                              </div>
                              {p.url ? (
                                <div className="erasmus-leafletTip__cta">
                                  {t("erasmus.ui.openWebsite")}
                                </div>
                              ) : null}
                            </div>
                          </Tooltip>
                        </CircleMarker>
                      ))}
                    </MapContainer>

                    <div className="erasmus-mapOverlay" aria-hidden="true" />
                  </div>
                </div>
              </section>
            </div>
          </div>

          {/* Sidebar unchanged */}
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">{t("sidebar.follow")}</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Facebook"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Instagram"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">{t("sidebar.useful")}</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">{t("about.fpep")}</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">
                      {t("admission.Akreditacija")}
                    </Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">{t("upis.title")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">{t("admission.Skolarina")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">{t("saradnja.erasmus")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">{t("saradnja.projekti")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">{t("studenti.dom")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">{t("navbar.Gallery")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">{t("navbar.News")}</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">{t("sidebar.study")}</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>{t("programs.osnovne")}</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      {t("osnovne.rfb")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      {t("osnovne.menadzment")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      {t("osnovne.pravo")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>{t("programs.master")}</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      {t("master.poslovnaEkonomija")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      {t("master.ekonomijaJavnogSektora")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      {t("master.pravo")}
                      <br />
                    </Link>
                  </li>

                  <li>
                    <span className="post-date">
                      <strong>{t("programs.specijalisticke")}</strong> <br />
                    </span>
                    <Link to="/menadzment-javnog-sektora-specijalisticke">
                      {t("specijalisticke.mjs")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment-profitnog-sektora-specijalisticke">
                      {t("specijalisticke.mps")}
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default Erasmus;
